export default {
  jobs: '求人',
  message: 'メッセージ',
  approach: 'アプローチ',
  profile: 'プロフィール'
}
